import { Dialog } from 'construct-ui';
import moment from 'moment';
import SearchDialogSingleContentComponent from "../../components/common/search-dialog-single-content.component";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import FileUploadComponent from "../../components/file/file-upload.component";
import { formats as FORMATS } from '../../config/constants';
import loginModel from '../../models/login.model';
import vocModel from '../../models/voc/voc.model';
import ViewBase from '../view-base.view';

export default function VocHistoryAddView() {
  ViewBase.call(this);

  let inputDataModel = {
    picUserId: "",
    revisedDueDate: moment().format(FORMATS.apiDateFormat),
    updateStatus: "",
    updateReason: "",
    updateNotes: "",
    fileMasterIds: "",
    isFromRequestor: false,
    isFileUploadOnly: false
  };

  let _selectedVocId;
  let _remainingFilesCount = 0;

  let _isVocConfiguredProperly = null;

  let _isPopupShowUserSearch = false;
  let _userSearchOptions;
  let updateStatusList = [];
  let updateReasonList = [];
  let _uploadingFiles = [];

  let _onPopupClose = (e) => { };
  let _onSaveComplete = (e) => { };

  let _cancel = (e) => {
    _onPopupClose(e);
  }

  let _save = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    if (_uploadingFiles && _uploadingFiles.length > 0) {

      vocModel.getVocInfo(
        (result) => {
          var info = result;
          var allowedMaximumFilesCount = info.remainingFilesCount;

          if (_uploadingFiles.length > allowedMaximumFilesCount) {

            this.showErrorMessage(allowedMaximumFilesCount <= 0 ?
              this.getText("LT00000464", "No more slot to accept more attachments.") :
              this.getText("LT00000465", "Not enough slots to accept more attachments. Number of empty slots left:") + " " + allowedMaximumFilesCount,
              this.getText("LT00000466", "Attachments Slot Not Enough"));

          } else {
            let filesFormData = new FormData();

            _uploadingFiles.forEach(function (v, i) {
              filesFormData.append("file", v);
            });

            vocModel.uploadMultipleFilesForVoc(
              (result) => {

                let uploadedFileInfo = result;
                inputDataModel.fileMasterIds = uploadedFileInfo.map(function (f) {
                  if (f && f.length > 0) return f[0].id;
                  return '';
                }).join('^');

                vocModel.updateVocInfo(
                  (result) => {
                    _onSaveComplete(result);
                  },
                  (error) => {
                    this.handleError(error);
                  },
                  _selectedVocId,
                  inputDataModel
                );
              },
              (error) => {
                this.handleError(error);
              },
              filesFormData
            );
          }
        }, (error) => {
          this.handleError(error);
        },
        _selectedVocId
      );

    } else {
      inputDataModel.fileMasterIds = '';

      vocModel.updateVocInfo(
        (result) => {
          _onSaveComplete(result);
        },
        (error) => {
          this.handleError(error);
        },
        _selectedVocId,
        inputDataModel
      );
    }

  }

  let _loadDefaultValues = () => {
    vocModel.getVocInfo(
      (result) => {
        var info = result;

        inputDataModel.picUserId = info.pic;
        inputDataModel.revisedDueDate = info.dueDate;
        inputDataModel.updateStatus = info.status;
        inputDataModel.updateReason = info.reason.trim();

        _remainingFilesCount = info.remainingFilesCount;

        if (inputDataModel.picUserId == null || inputDataModel.picUserId.trim().length == 0) {
          inputDataModel.isFileUploadOnly = false;
        }

        _loadVocUpdateStatues();
        _loadVocUpdateReasons();
      }, (error) => {
        _remainingFilesCount = 0;

        this.handleError(error);
      },
      _selectedVocId
    );
  }

  let _loadVocUpdateStatues = () => {
    vocModel.getVocUpdateStatuses(
      (result) => {
        updateStatusList = [];

        if (result) {
          result.map(s => {
            updateStatusList.push({
              code: s.statuS_CC,
              status: s.statuS_NM
            });
          });
        }

        _isVocConfiguredProperly = updateStatusList.length > 0;
      }, (error) => {
        this.handleError(error);
      },
      _selectedVocId
    );
  }

  let _loadVocUpdateReasons = () => {
    vocModel.getVocUpdateReasons(
      (result) => {
        updateReasonList = [];
        updateReasonList.push({
          code: "",
          reason: this.getText("LT00000201", "Please select"),
        });

        if (result) {
          result.map(r => {
            updateReasonList.push({
              code: r.group3,
              reason: r.value
            });
          });
        }
      }, (error) => {
        this.handleError(error);
      }
    );
  }

  let _getUpdateNotes = (e) => {
    inputDataModel.updateNotes = e.target.value;
  }

  let _showPopupUserSearch = () => {
    _isPopupShowUserSearch = true;
    _userSearchOptions = {
      name: 'Users',
      note: "This will search for User ID or User Name",
      category: 'user',
      values: inputDataModel.picUserId,
      countryCode: loginModel.credentials.country,
      onOk: (e) => { inputDataModel.picUserId = e[0].code; _isPopupShowUserSearch = false; },
      onCancel: () => { _isPopupShowUserSearch = false; }
    };
  }

  return {
    oninit: (vnode) => {

      if (vnode.attrs.onPopupClose) {
        _onPopupClose = vnode.attrs.onPopupClose;
      }

      if (vnode.attrs.onSaveComplete) {
        _onSaveComplete = vnode.attrs.onSaveComplete;
      }

      if (vnode.attrs.vocId) {
        _selectedVocId = vnode.attrs.vocId;
      }

      if (vnode.attrs.isFromRequestor) {
        inputDataModel.isFromRequestor = vnode.attrs.isFromRequestor;
      }

      if (vnode.attrs.isFileUploadOnly) {
        inputDataModel.isFileUploadOnly = vnode.attrs.isFileUploadOnly;
      }

      _loadDefaultValues();

    },
    view: () => {
      return [
        m('.row',
          m('col-md-12',
            !inputDataModel.isFromRequestor && _isVocConfiguredProperly != null && !_isVocConfiguredProperly && m('.card',
              m('.card-body',
                m('.alert.alert-danger', { role: 'alert' }, [
                  m('h4.alert-heading', this.getText("LT00000467", "VOC Status Not Configured")),
                  m('p', [
                    m('span', this.getText("LT00000468", "Please request administrator to grant you the permission to update VOC status."))
                  ]),

                ])
              )
            ),
            (inputDataModel.isFromRequestor || _isVocConfiguredProperly) && m('.card',
              m('.card-body',
                m('form#mainForm.needs-validation[novalidate]',
                  inputDataModel.isFileUploadOnly && _remainingFilesCount <= 0 && m('.alert.alert-danger', { role: 'alert' }, [
                    m('h4.alert-heading', this.getText("LT00000469", "No Slot for More Attachments")),
                    m('p', [
                      m('span', this.getText("LT00000470", "There are no more slot left for more attachments to be uploaded."))
                    ]),

                  ]),
                  m('.row',
                    !inputDataModel.isFromRequestor && !inputDataModel.isFileUploadOnly && m('.col-md-6.g-4',
                      m('label.form-label', this.getText("LT00000471", "Person-In-Charge"), m('span.redText', "*")),
                      m('input[required][maxlength=50][type=text][placeholder=' + this.getText("LT00000471", "Person-In-Charge") + '].form-control.form-control-bg',
                        {
                          onclick: () => { _showPopupUserSearch(); },
                          value: inputDataModel.picUserId
                        }),
                      m('.invalid-feedback', this.getText("LT00000472", "Please specify person-in-charge."))
                    ),
                    !inputDataModel.isFromRequestor && !inputDataModel.isFileUploadOnly && m('.col-md-6.g-4',
                      m('label.form-label', this.getText("LT00000473", "Revised Due Date"), m('span.redText', "*")),
                      m(DatePickerComponent, {
                        class: 'form-control',
                        date: this.dateStringFormat(inputDataModel.revisedDueDate),
                        onselect: (e) => {
                          inputDataModel.revisedDueDate = moment(e.detail.date).format(FORMATS.apiDateFormat);
                        }
                      })
                    ),
                    !inputDataModel.isFromRequestor && !inputDataModel.isFileUploadOnly && m('.col-md-6.g-4',
                      m('label.form-label', this.getText("LT00000474", "Update Status"), m('span.redText', "*")),
                      m('select#updateStatus.form-select', {
                        value: inputDataModel.updateStatus,
                        onchange: (e) => {
                          inputDataModel.updateStatus = updateStatusList[e.target.selectedIndex].code;
                        }
                      },
                        updateStatusList.map(s => [
                          m('option', {
                            value: s.code,
                            selected: s.code == inputDataModel.updateStatus
                          },
                            s.status
                          )
                        ])),
                    ),
                    !inputDataModel.isFromRequestor && !inputDataModel.isFileUploadOnly && m('.col-md-6.g-4',
                      m('label.form-label', this.getText("LT00000475", "Update Reason")),
                      m('select#updateReason.form-select', {
                        value: inputDataModel.updateReason,
                        onchange: (e) => {
                          inputDataModel.updateReason = updateReasonList[e.target.selectedIndex].code;
                        }
                      },
                        updateReasonList.map(r => [
                          m('option', {
                            value: r.code,
                            selected: r.code == inputDataModel.updateReason
                          },
                            r.reason
                          )
                        ])),
                    ),
                    !inputDataModel.isFromRequestor && !inputDataModel.isFileUploadOnly && m('.col-md-12.g-4',
                      m('label.form-label', this.getText("LT00000476", "Update Notes"), m('span.redText', "*")),
                      m('textarea[required]#txtContent.form-control.form-control-bg',
                        {
                          onchange: _getUpdateNotes,
                          style: "height: 84px;",
                          maxlength: 255
                        },
                        inputDataModel.updateNotes
                      ),
                      m('.invalid-feedback', this.getText("LT00000477", "Please specify an update notes."))
                    ),
                    _remainingFilesCount > 0 && m('.col-md-12.g-4',
                      m('label.form-label', this.getText("LT00000478", "Attached Files")),
                      m(FileUploadComponent, {
                        acceptableFileTypes: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.jpg', '.jpeg', '.png'],
                        onGettingFiles: (e) => {
                          _uploadingFiles = e;
                        }
                      })
                    )
                  ),
                  !inputDataModel.isFileUploadOnly && _remainingFilesCount <= 0 && m('span.text-warning', { style: "font-size: .875em !important;" }, '* There are no more slot left for more attachments to be uploaded.'),
                )
              ),
              m('.card-footer',
                m('.col-md-12.gap-2.d-flex.justify-content-end',
                  (!inputDataModel.isFileUploadOnly || _remainingFilesCount > 0) && m("button.btn.btn-primary[type='button']", { onclick: _save }, this.getText("LT00000022", "Save")),
                  m("button.btn.btn-white[type='button']", { onclick: _cancel }, this.getText("LT00000021", "Close"))
                )
              )
            )
          ),
        ),
        m(Dialog, {
          isOpen: _isPopupShowUserSearch,
          onClose: () => { _isPopupShowUserSearch = false; },
          title: this.getText("LT00000479", "User Search"),
          content: m(SearchDialogSingleContentComponent, _userSearchOptions),
          "class": "cui-dialog-xl"
        }),
        this.getBaseViews()
      ];
    },
  };
}
